import {connect} from 'react-redux';

// component
import GettingStarted from './GettingStarted';

const mapStateToProps = ({student}) => ({student});

export default connect(mapStateToProps)(GettingStarted);
